<template>
  <div class="contents contents--pt">
    <section class="Form _min-h">
      <div class="inner">
        <div class="Form--pt">
          <p class="Form__tx Form__tx--mb_sm">
            変更後のご住所をご入力ください。
          </p>
          <div id="address-form" :class="{'Form__area _show' : userInfo.is_living_oversea , 'Form__area': !userInfo.is_living_oversea}">
            <div class="Form__input_box Form__input_box--lg">
              <div class="Form__check_box">
                <label for="address" class="Check__box Form__check_box_label _ft-spacing60 _ft-cl07">
                  <input id="address" v-model="$v.userInfo.is_living_oversea.$model" type="checkbox" name="checkbox01">
                  <span class="Check__box_inner" />海外にお住まいの方はチェックを入れてください
                </label>
              </div>
            </div>
            <div v-show="!userInfo.is_living_oversea" :class="`Form__input_box Form__input_box--mb_md Form__input_box--lg ${$v.userInfo.postal_code.$error ? '_error' : ''}`">
              <div class="Form__input_heda Form__input_head_required Form__input_head_required_tx_box">
                郵便番号
              </div>
              <div class="Form__postal_box">
                <input
                  v-model.trim.lazy="$v.userInfo.postal_code.$model"
                  class="Form__input Form__input_postal"
                  type="text"
                  placeholder="1200025"
                  @change="getPostCodeAddress(userInfo)"
                >
              </div>
              <div class="Form__error_box">
                <div class="Form__error_tx">
                  <label v-if="!$v.userInfo.postal_code.required">郵便番号を入力してください</label>
                  <label v-if="!$v.userInfo.postal_code.regexPostCode">7桁の数値にしてください</label>
                </div>
              </div>
            </div>
            <div v-show="userInfo.is_living_oversea" :class="`Form__input_box Form__input_box--mb_md Form__input_box--lg ${$v.userInfo.postal_code_en.$error ? '_error' : ''}`">
              <div class="Form__input_heda Form__input_head_required Form__input_head_required_tx_box">
                郵便番号
              </div>
              <div class="Form__postal_box">
                <input
                  v-model.trim.lazy="$v.userInfo.postal_code_en.$model"
                  class="Form__input Form__input_postal"
                  type="text"
                  placeholder="1200025"
                >
              </div>
              <div class="Form__error_box">
                <div class="Form__error_tx">
                  <label v-if="!$v.userInfo.postal_code_en.maxLength">郵便番号の最大長20</label>
                </div>
              </div>
            </div>
            <div v-show="!userInfo.is_living_oversea" id="jp-address" class="Form__input_address_jp">
              <div :class="`Form__input_box Form__input_box--lg ${$v.userInfo.prefecture.$error ? '_error' : ''}`">
                <div class="Form__input_heda Form__input_head_required">
                  都道府県
                </div>
                <div class="Select__box_area">
                  <select
                    v-model="$v.userInfo.prefecture.$model"
                    class="Select__box"
                    name="address"
                  >
                    <option v-for="prefecture in prefectures" :key="prefecture.code" :value="prefecture.name">
                      {{ prefecture.name }}
                    </option>
                  </select>
                </div>
                <div class="Form__error_box">
                  <div class="Form__error_tx">
                    都道府県を選択してください
                  </div>
                </div>
              </div>
              <div :class="`Form__input_box Form__input_box--lg ${$v.userInfo.address1.$error ? '_error' : ''}`">
                <div class="Form__input_heda Form__input_head_required">
                  市区町村・番地
                </div>
                <input
                  v-model="$v.userInfo.address1.$model"
                  class="Form__input"
                  type="text"
                  placeholder="東京都港区南青山1-2-3"
                >
                <div class="Form__error_box">
                  <div class="Form__error_tx">
                    <label v-if="!$v.userInfo.address1.required">市区町村・番地を入力してください</label>
                    <label v-if="!$v.userInfo.address1.maxLength">市区町村・番地大長さ255</label>
                  </div>
                </div>
              </div>
              <div class="Form__input_box Form__input_box--lg">
                <div class="Form__input_heda">
                  建物名・号室
                </div>
                <input
                  v-model="$v.userInfo.address2.$model"
                  class="Form__input"
                  type="text"
                  placeholder="メロンハイツ101号室"
                >
              </div>
            </div>
            <div v-show="userInfo.is_living_oversea" id="en-address" class="Form__input_address_en">
              <div :class="`Form__input_box Form__input_box--lg ${$v.userInfo.address1_en.$error ? '_error' : ''}`">
                <div class="Form__input_heda Form__input_head_required">
                  住所
                </div>
                <input
                  v-model="$v.userInfo.address1_en.$model"
                  class="Form__input"
                  type="text"
                  placeholder="Chicago, IL 00000-0000 U.S.A"
                >
                <div class="Form__error_box">
                  <div class="Form__error_tx">
                    <label v-if="!$v.userInfo.address1_en.required">住所を入力してください</label>
                    <label v-if="!$v.userInfo.address1_en.maxLength">住所大長さ255</label>
                  </div>
                </div>
              </div>
              <div :class="`Form__input_box Form__input_box--lg  ${$v.userInfo.address2_en.$error ? '_error' : ''}`">
                <div class="Form__input_heda">
                  建物名・号室
                </div>
                <input
                  v-model="$v.userInfo.address2_en.$model"
                  class="Form__input"
                  type="text"
                  placeholder="101 Melon Ave"
                >
                <div class="Form__error_box">
                  <div class="Form__error_tx">
                    <label v-if="!$v.userInfo.address2_en.maxLength">建物名・号室大長さ255</label>
                  </div>
                </div>
              </div>
            </div>
            <button
              :disabled="$v.userInfo.$invalid"
              class="Btn__blue Form__btn Form__btn--sm_sp Form__btn--mt_md Form__btn--mt_lg Form__btn--mt_sp_lg"
              @click="updateUserInfo()"
            >
              変更する
            </button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import authService from '@/services/authService'
import { requiredIf, maxLength } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import { redirect } from '@/helpers'
import { regexPostCode } from '@/helpers/validations'
import { prefectures } from 'jp-prefectures'

const validations = {
  userInfo: {
    postal_code: {
      required: requiredIf(function() {
        return !this.userInfo.is_living_oversea
      }),
      regexPostCode
    },
    prefecture: {
      required: requiredIf(function() {
        return !this.userInfo.is_living_oversea
      }),
      maxLength: maxLength(255)
    },
    address1: {
      required: requiredIf(function() {
        return !this.userInfo.is_living_oversea
      }),
      maxLength: maxLength(255)
    },
    country: {},
    address2: {
      maxLength: maxLength(255)
    },
    address2_en: {
      maxLength: maxLength(255)
    },
    address1_en: {
      required: requiredIf(function() {
        return this.userInfo.is_living_oversea
      }),
      maxLength: maxLength(255)
    },
    is_living_oversea: { },
    postal_code_en: {
      maxLength: maxLength(20)
    }
  }
}
export default {
  name: 'ChangeAddress',
  mixins: [validationMixin],
  data() {
    return {
      userInfo: {
        postal_code: '',
        prefecture: '',
        address1: '',
        address2: '',
        is_living_oversea: false,
        address1_en: '',
        address2_en: '',
        country: '',
        postal_code_en: ''
      },
      showError: false
    }
  },
  computed: {
    prefectures
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      await this.getUserInfo()
    },
    async getUserInfo() {
      this.$store.dispatch('loading/updateLoading', true)
      const response = await authService.getUserInfo()
      const userInfoData = response.user.user
      this.userInfo = Object.seal(this.userInfo)
      this.userInfo.address1 = userInfoData.address1
      this.userInfo.address2 = userInfoData.address2
      this.userInfo.country = userInfoData.country
      this.userInfo.is_living_oversea = false
      if (userInfoData.country && userInfoData.country !== '日本') {
        this.userInfo.is_living_oversea = true
        this.userInfo.address1_en = userInfoData.address1
        this.userInfo.address2_en = userInfoData.address2
        this.userInfo.postal_code_en = userInfoData.postcode
      } else {
        this.userInfo.postal_code = userInfoData.postcode
        this.userInfo.prefecture = userInfoData.prefecture
      }
      this.$store.dispatch('loading/updateLoading', false)
    },
    getPostCodeAddress(userInfo) {
      var postal_code = require('japan-postal-code')
      const postcode = this.userInfo.postal_code
      if (postcode[3] !== '-') {
        postal_code.get(postcode, function(address) {
          userInfo.prefecture = address.prefecture
          userInfo.address1 = address.city + address.area
        })
      }
    },
    async updateUserInfo() {
      this.$v.userInfo.$touch()
      if (this.$v.userInfo.$invalid) {
        return
      }
      const redirectPath = '/change/address/thanks'
      let updateUserInfo = {}
      if (this.userInfo.is_living_oversea) {
        updateUserInfo = {
          address1: this.userInfo.address1_en,
          address2: this.userInfo.address2_en,
          country: '海外',
          postal_code: this.userInfo.postal_code_en
        }
      } else {
        updateUserInfo = this.userInfo
        updateUserInfo.country = '日本'
      }
      this.$store.dispatch('loading/updateLoading', true)
      await authService.updateUserInfo(updateUserInfo)
      this.$store.dispatch('loading/updateLoading', false)
      redirect(redirectPath)
    }
  },
  validations: validations
}
</script>
